import useBaseConfiguration from '../base/baseConfiguration'
import useBaseSettings from '../base/baseSettings'
import useBaseProducts from '../base/baseProducts'
import useBaseUserConfiguration from '../base/baseUserConfiguration'
import useBaseAdConfiguration from '../base/baseAdConfiguration'
import useBaseHomeConfiguration from '../base/baseHomeConfiguration'

import useParameters from './shared/appUrlParameters'
import useAppConfiguration from './prod/appConfiguration'
import useAppSettings from './shared/appSettings'
import useAppProducts from './shared/appProducts'
import useAppUserConfiguration from './prod/appUserConfiguration'
import useAppAdConfiguration from './shared/appAdConfiguration'
import useAppHomeConfiguration from './shared/appHomeConfiguration'

import useJweatherGlobalsTransformer from './shared/appJweatherGlobalsTransformer'
import useBaseJweatherConfig from '../base/baseJweatherConfig'
import useAppJweatherConfig from './shared/appJweatherConfig'

import { deepMerge } from '@/helpers/deepMerge'

window.$App = window.$App || {}
window.$App.globals = window.$App?.globals || {}

const parameters = useParameters()

const baseConfiguration = useBaseConfiguration(parameters)
const appConfiguration = useAppConfiguration(parameters)
const siteConfiguration = window.$App.globals.configuration || {}

const baseUserConfiguration = useBaseUserConfiguration(parameters)
const appUserConfiguration = useAppUserConfiguration(parameters)
const siteUserConfiguration = window.$App.globals.user || {}

const baseSettings = useBaseSettings(parameters)
const appSettings = useAppSettings(parameters)
const siteSettings = window.$App.globals.settings || {}

const baseProducts = useBaseProducts(parameters)
const appProducts = useAppProducts(parameters)
const siteProducts = window.$App.globals.products || {}

window.$App.globals.configuration = deepMerge({}, baseConfiguration, appConfiguration, siteConfiguration)
window.$App.globals.settings = deepMerge({}, baseSettings, appSettings, siteSettings)
window.$App.globals.products = deepMerge({}, baseProducts, appProducts, siteProducts)
window.$App.globals.user = deepMerge({}, baseUserConfiguration, appUserConfiguration, siteUserConfiguration)

// Ad configuration needs to be done after the merging of the configuration globals to make sure the brand is set
const baseAdConfiguration = useBaseAdConfiguration(window.$App.globals.configuration)
const appAdConfiguration = useAppAdConfiguration(parameters)
const siteAdConfiguration = window.$App.globals.ads || {}
window.$App.globals.ads = deepMerge({}, baseAdConfiguration, appAdConfiguration, siteAdConfiguration)

// Home configuration also needs the merged brand, plus the /brand/{brand} url parameter
const baseHomeConfiguration = useBaseHomeConfiguration(parameters)
const appHomeConfiguration = useAppHomeConfiguration({ ...window.$App.globals.configuration, ...parameters })
const siteHomeConfiguration = window.$App.globals.home || {}
window.$App.globals.home = deepMerge({}, baseHomeConfiguration, appHomeConfiguration, siteHomeConfiguration)

useJweatherGlobalsTransformer(parameters)
useBaseJweatherConfig(window.$App.globals.configuration)
useAppJweatherConfig(parameters)
